import React from "react";

export const Button = ({
                           children,
                           className = "",
                           variant = "default",
                           ...props
                       }) => {
    const base =
        "px-4 py-2 rounded-xl font-medium transition duration-200";

    const styles = {
        default: "bg-indigo-600 text-white hover:bg-indigo-700",
        outline: "border border-indigo-600 text-indigo-600 hover:bg-indigo-50",
    };

    return (
        <button
            className={`${base} ${styles[variant] || styles.default} ${className}`}
            {...props} // 🔥 ESENȚIAL — transmite onClick
        >
            {children}
        </button>
    );
};